import React from "react";
import StationGraphs from "../../components/Graph/StationGraphs";
import StationAutocomplete from "../../components/inputs/StationsAutocomplete/StationAutocomplete";
import Stack from "@mui/material/Stack";


const StationAnalytics = ({selectedStation, setSelectedStation}) => {
        return <Stack gap={2}>
        <StationAutocomplete selectedStation={selectedStation}
                             setSelectedStation={setSelectedStation}
                             waitFocus={false}
                             initializeFirst={true}
                             fullWidth
                             stationFilters={{
                                 accept_mod1: true
                             }}
                             sx={{alignSelf: "flex-start"}}/>
        <StationGraphs stationId={selectedStation?.id ?? null} station={selectedStation} />
    </Stack>
}

export default StationAnalytics;